import { styled } from '@innowise-group/mui-kit';

export const Fieldset = styled.fieldset`
  min-width: 0;
  margin: 0;
  padding: 0.125rem 0.6875rem 0.6875rem;
  border: 1px solid ${({ theme }) => theme.palette.general.lightGrey[60]};
  border-radius: 10px;
`;

export const Legend = styled.legend`
  margin-left: 1.125rem;
  padding: 0 0.5rem;
  color: ${({ theme }) => theme.palette.general.lightGrey[70]};
  ${({ theme }) => theme.fonts.primary[30]};
  line-height: 1.25rem;
  letter-spacing: 0.5px;
`;

export const Panel = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  column-gap: 0.75rem;
  padding: 0.125rem 0.75rem 0.75rem;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.general.lightGrey[20]};

  & .MuiOutlinedInput-root:not(.Mui-disabled) {
    background-color: ${({ theme }) => theme.palette.general.paper};
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    grid-template-columns: minmax(0, 1fr);
  }
`;
